import { Injectable } from '@angular/core';
import * as moment from 'moment';

/**
 * Though old CASLink monkey-patched the String prototype, we know better than that now...
 */

@Injectable({
    providedIn: 'root'
})
export class StringUtilsService {
    public static $name: string = 'stringUtils';

    private standardTimeFormat: string = 'h:mmA';
    private militaryTimeFormat: string = 'HH:mm';

    public minutesToTimeString(minutes: number, military?: boolean, dtformat: string = this.standardTimeFormat): string {
        return this.toTimeString(minutes, 'minutes', military, dtformat);
    }

    public secondsToTimeString(seconds: number, military?: boolean, dtformat: string = this.standardTimeFormat): string {
        return this.toTimeString(seconds, 'seconds', military, dtformat);
    }

    public timeStringToSeconds(timeStr: string, dtformat: string = this.standardTimeFormat): number {
        // tslint:disable-next-line: no-magic-numbers
        return this.timeStringToMinutes(timeStr, dtformat) * 60;
    }

    private toTimeString(
        input: number,
        inputFormat: moment.unitOfTime.DurationConstructor,
        military?: boolean,
        outputFormat: string = this.standardTimeFormat
    ): string {
        // @ts-ignore
        let militaryTime: string = moment(moment.duration(input, inputFormat).asMilliseconds()).utc().format(this.militaryTimeFormat);

        if (military) {
            return militaryTime;
        } else {
            return moment(militaryTime, this.militaryTimeFormat).format(outputFormat);
        }
    }

    private timeStringToMinutes(timeStr: string, dtformat: string = this.standardTimeFormat): number {
        // Convert to military time so we don't have to manually calculate whether to add 12 to hours or not..
        let militaryTime: string = moment(timeStr, dtformat).format(this.militaryTimeFormat);

        // Convert to Moment object
        let momentObj = moment(militaryTime, this.militaryTimeFormat);

        // tslint:disable-next-line: no-magic-numbers
        let result = (momentObj.hours() * 60) + momentObj.minutes();

        return result;
    }
}
